<div class="loading-shade" *ngIf="(loaderService.isLoading$ | async) > 0">
    <mat-spinner></mat-spinner>
</div>
<div class="loading-shade" *ngIf="(loaderService.isLoading$ | async) > 0">
    <span>Processing...</span>
</div>